export default "__VITE_ASSET__D7P81lFb__"